import { Component, input, output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ingsv-adm-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss']
})
export class RadioComponent {
  readonly data = input<any[]>([]);
  readonly selectedValue = input('');

  readonly selected = output<any>();

  readonly radioName = `radio-${Math.random().toString(36).slice(2, 10)}`;

  onSelect(event: Event, value: any, disabled = false): void {
    // Keep this as a controlled component: the parent owns selection state.
    event.preventDefault();
    if (!disabled && value !== this.selectedValue()) {
      this.selected.emit(value);
    }
  }
}
